import api from "./api";
import { ensureArray } from "../utils/plantillas";

const makeService = (endpoint) => ({
    getAll: async () => {
        try {
            const res = await api.get(`/${endpoint}`);
            // normalize items for each component
            if (Array.isArray(res.data)) {
                return res.data.map(c => ({ ...c, items: ensureArray(c.items) }));
            }
            return res.data;
        } catch (error) {
            console.error(`Error al cargar ${endpoint}:`, error);
            return [];
        }
    },
    getById: async (id) => {
        try {
            const res = await api.get(`/${endpoint}/${id}`);
            const data = res.data;
            if (data) {
                data.items = ensureArray(data.items);
            }
            return data;
        } catch (error) {
            console.error(`Error al obtener ${endpoint}/${id}:`, error);
            throw error;
        }
    },
    create: async (data) => {
        try {
            const res = await api.post(`/${endpoint}`, data);
            return res.data;
        } catch (error) {
            console.error(`Error al crear en ${endpoint}:`, error);
            throw error;
        }
    },
    delete: async (id) => {
        try {
            const res = await api.delete(`/${endpoint}/${id}`);
            return res.data;
        } catch (error) {
            console.error(`Error al eliminar de ${endpoint}:`, error);
            throw error;
        }
    },
    update: async (id, data) => {
        try {
            const res = await api.put(`/${endpoint}/${id}`, data);
            return res.data;
        } catch (error) {
            console.error(`Error al actualizar en ${endpoint}:`, error);
            throw error;
        }
    }
});

export const componenteService = {
    gabinete: makeService("gabinetes"),
    puerta: makeService("puertas"),
    accesorio: makeService("accesorios"),
    materialesFrio: makeService("materiales-frio"),
    materialesElectricos: makeService("materiales-electricos"),
    unidadCondensadora: makeService("unidad-condensadora"),
    evaporadorCubico: makeService("evaporador-cubico"),
    forzador: makeService("forzador")
};
